import AlertBanner from './blocks/alert-banner/browser';

const Blocks = {
	'alert-banner': AlertBanner,
};

export { Blocks };
